import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { generateButtonSx } from "../../../utils/elementor-style-override";

const SendPasswordSetupDialog = ({ open, onClose, onConfirm, loading, userName, userEmail }) => {
	const handleConfirm = async () => {
		if (!onConfirm) {
			return;
		}

		const response = await onConfirm();

		if (response?.success) {
			onClose();
		}
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					fontWeight: 600,
				}}
			>
				Set New Password
				<IconButton onClick={onClose} size="small" sx={{ backgroundColor: "transparent !important" }}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>

			<DialogContent>
				<Stack spacing={2} mt={1}>
					<Typography variant="body2" color="text.secondary">
						A one-time set new password link will be generated and sent to this user by email.
					</Typography>

					<Box
						sx={{
							border: "1px solid",
							borderColor: "divider",
							borderRadius: 2,
							px: 2,
							py: 1.5,
							backgroundColor: "#F8F8F8",
						}}
					>
						<Typography variant="caption" color="text.secondary">
							Recipient
						</Typography>
						<Typography variant="body2" fontWeight={600}>
							{userName || "User"}
						</Typography>
						<Typography variant="body2" color="text.secondary">
							{userEmail || "No email available"}
						</Typography>
					</Box>

					<Typography variant="body2" color="text.secondary">
						The link stays active until the agent sets a new password, and works only once. Sending a new link automatically invalidates
						the previous one.
					</Typography>
				</Stack>
			</DialogContent>

			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button
					variant="outlined"
					onClick={onClose}
					sx={{
						textTransform: "none",
						backgroundColor: "transparent !important",
						...generateButtonSx({ bg: "#F4F4F5 !important", text: "#1D54A2" }, { bg: "#F4F4F5 !important", text: "#1D54A2" }),
					}}
				>
					Close
				</Button>
				<Button
					onClick={handleConfirm}
					variant="contained"
					disabled={loading || !userEmail}
					sx={{
						textTransform: "none",
						...generateButtonSx({ bg: "#EBF5FF !important", text: "#1D54A2" }, { bg: "#EBF5FF !important", text: "#1D54A2" }),
					}}
				>
					{loading ? "Sending..." : "Send Email"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default SendPasswordSetupDialog;
